import { render, staticRenderFns } from "./CuCastingThumb.vue?vue&type=template&id=5a5e5e6a"
import script from "./CuCastingThumb.vue?vue&type=script&lang=js"
export * from "./CuCastingThumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports